import { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    // Validation
    if (!formData.name || !formData.email || !formData.message) {
      setStatus({ type: "error", message: "Please fill in all required fields." });
      setLoading(false);
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setStatus({ type: "error", message: "Please enter a valid email address." });
      setLoading(false);
      return;
    }

    try {
      // ============================================
      // TODO: Replace with your actual API endpoint
      // This will be connected to your database later
      // ============================================

      // Simulating API call for now
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // For now, log the data (remove later)
      console.log("Form Data Submitted:", formData);

      // Uncomment below when backend is ready:
      // const response = await fetch("https://your-api.com/api/contact", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(formData),
      // });
      // if (!response.ok) throw new Error("Submission failed");

      setStatus({
        type: "success",
        message: "Thank you for reaching out! We have received your message and will get back to you within 24 hours.",
      });

      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: "Something went wrong. Please try again or contact us directly via phone or email.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main id="main">
      <section id="contact" className="contact">
        <div className="container">
          <header className="section-header">
            <h2>Contact Us</h2>
            <p>Have a project in mind? We would love to hear from you. Reach out and let us start building something great together.</p>
          </header>

          <div className="row gy-4">
            {/* Contact Information */}
            <div className="col-lg-6">
              <div className="row gy-4">
                <div className="col-md-6">
                  <div className="info-box">
                    <i className="bi bi-geo-alt" />
                    <h3>Our Office</h3>
                    <p>
                      BSF Colony Sai Town , Nainod


                      <br />
                      Indore, Madhya Pradesh 
                      <br />
                      India 453112
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="info-box">
                    <i className="bi bi-telephone" />
                    <h3>Call Us</h3>
                    <p>
                      {/* <a href="tel:+919340116643">+91 9340 116 643</a> */}
                      {/* <br /> */}
                      <a href="tel:+917000191398">+91 7000 191 398</a>
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="info-box">
                    <i className="bi bi-envelope" />
                    <h3>Email Us</h3>
                    <p>
                      <a href="mailto:info@sdtechsolutions.com">info@sdtechsolutions.com</a>
                      <br />
                      <a href="mailto:support@sdtechsolutions.com">support@sdtechsolutions.com</a>
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="info-box">
                    <i className="bi bi-clock" />
                    <h3>Business Hours</h3>
                    <p>
                      Monday — Saturday
                      <br />
                      09:00 AM — 07:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-6">
              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Full Name *"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email Address *"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Your Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject / Service Interest"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-12">
                    <textarea
                      name="message"
                      className="form-control"
                      rows={6}
                      placeholder="Tell us about your project, requirements, or any questions you have... *"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    {loading && <div className="loading">Sending your message...</div>}
                    {status.message && (
                      <div
                        className={status.type === "success" ? "sent-message" : "error-message"}
                        style={{ display: "block" }}
                      >
                        {status.message}
                      </div>
                    )}
                    <button
                      type="submit"
                      disabled={loading}
                      style={{
                        background: loading ? "#ccc" : "#0070f3",
                        color: "#fff",
                        border: "none",
                        padding: "12px 40px",
                        borderRadius: "50px",
                        fontSize: "1rem",
                        fontWeight: "600",
                        cursor: loading ? "not-allowed" : "pointer",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {loading ? "Sending..." : "Send Message"}
                      {!loading && <i className="bi bi-send ms-2" />}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}